import { render } from "./documentTemplatesManagement.vue?vue&type=template&id=c9ef4e98"
import script from "./documentTemplatesManagement.vue?vue&type=script&lang=js"
export * from "./documentTemplatesManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__